export default {
      id: "instagram-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.159f8dce.svg#instagram",
      toString: function () {
        return this.url;
      }
    }